export default "__VITE_ASSET__B7u4RRwP__"